import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import {
  CategoryFiltersResponse,
  CategoryFilterUsage,
  Filter,
  FilterRequest,
  UpdateFilterRequest
} from '../models/filter.model';

@Injectable({ providedIn: 'root' })
export class FilterService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${API_BASE_URL}/filters`;

  getAll(): Observable<Filter[]> {
    return this.http.get<Filter[]>(this.baseUrl);
  }

  create(request: FilterRequest): Observable<Filter> {
    return this.http.post<Filter>(this.baseUrl, request);
  }

  update(id: string, request: UpdateFilterRequest): Observable<Filter> {
    return this.http.put<Filter>(`${this.baseUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  getCategoryFilters(
    categoryId: string,
    options?: { includeAllOptions?: boolean }
  ): Observable<CategoryFiltersResponse> {
    const params = options?.includeAllOptions
      ? { includeAllOptions: 'true' }
      : undefined;
    return this.http.get<CategoryFiltersResponse>(
      `${API_BASE_URL}/categories/${categoryId}/filters`,
      { params }
    );
  }

  assignToCategory(categoryId: string, filterId: string): Observable<void> {
    return this.http.post<void>(
      `${API_BASE_URL}/categories/${categoryId}/filters/${filterId}`,
      {}
    );
  }

  unassignFromCategory(categoryId: string, filterId: string): Observable<void> {
    return this.http.delete<void>(
      `${API_BASE_URL}/categories/${categoryId}/filters/${filterId}`
    );
  }

  getCategoryFilterUsage(
    categoryId: string,
    filterId: string
  ): Observable<CategoryFilterUsage> {
    return this.http.get<CategoryFilterUsage>(
      `${API_BASE_URL}/categories/${categoryId}/filters/${filterId}/usage`
    );
  }

  setCategoryFilterOrder(categoryId: string, filterIds: string[]): Observable<void> {
    return this.http.put<void>(`${API_BASE_URL}/categories/${categoryId}/filters/order`, {
      filterIds
    });
  }
}
